import { defineMessages } from 'react-intl';

export default defineMessages({
  allCommitsLabel: {
    id: 'frontbucket.commitList.refSelector.allCommitsLabel',
    description:
      'Label for the ref selector on the commits page when viewing all commits instead of those for a specific ref',
    defaultMessage: 'All branches',
  },
});
